import produce from "immer";

const defaultState = {
    item: null,
    error: null,
    voucherError: null,
    downloading: false
};

export default function(state = defaultState, action) {
    switch (action.type) {
        case 'FETCH_ORDER_DETAIL':
            return defaultState;
        case 'ORDER_DETAIL_FETCHED':
            return produce(state, draft => {
                draft.item = {
                    voucherAmount: action.orderDetail.voucherAmount,
                    orderedAt: action.orderDetail.orderedAt,
                    rewardFriendlyName: action.orderDetail.rewardFriendlyName,
                    voucherCodes: action.orderDetail.voucherCodes
                };
                draft.error = null;
            });
        case 'ORDER_DETAIL_NOT_FOUND':
            return produce(state, draft => {
                draft.item = null;
                draft.error = "ORDER_DETAIL_NOT_FOUND";
            });
        case 'DOWNLOAD_VOUCHERS':
            return produce(state, draft => {
                draft.downloading = true;
            });
        case 'VOUCHERS_DOWNLOADED':
            return produce(state, draft => {
                draft.downloading = false;
            });
        case 'VOUCHERS_NOT_FOUND':
            return produce(state, draft => {
               draft.downloading = false;
               draft.voucherError = "VOUCHERS_NOT_FOUND";
            });
        case 'DOWNLOAD_VOUCHERS_FAILED':
            return produce(state, draft => {
                draft.downloading = false;
                draft.voucherError = "DOWNLOAD_VOUCHERS_FAILED";
            });
        default:
            return state;
    }
}